import { match, P } from 'ts-pattern';
import { computeShopNowIncentive, isCreditClaim } from '~/utils/claimLineItem';
import { makeCrewClaimLoader, redirect } from '~/utils/routing';

export const { loader, useLoaderData } = makeCrewClaimLoader(({ context }) =>
  match(context)
    // shop now not offered, skip to address
    .with({ order: { offerShopNow: P.nullish } }, () => redirect('../address'))
    // the user selected shop now at resolution, we can go directly to start
    .when(
      ({ crewClaim }) => crewClaim.claimLineItems.some((item) => item.shopNow),
      () => redirect('start'),
    )
    // show the page with incentive
    .with(
      { order: { offerShopNow: P.not(P.nullish) } },
      ({ crewClaim }) => crewClaim.claimLineItems.some(isCreditClaim),
      ({ order, crewClaim }) => {
        const incentive = computeShopNowIncentive(
          crewClaim.claimLineItems,
          order.offerShopNow.shopNowIncentive,
        );

        return {
          headline:
            order.offerShopNow.shopNowHeadline ?? 'Shop now with your credit',
          description:
            order.offerShopNow.shopNowDescription ??
            'Use your credit to shop now for a replacement item.',
          credit: incentive.lineItemTotal,
          incentive: incentive.amount,
        };
      },
    )
    .otherwise(() => redirect('../address')),
);
